/**
 * pdf.js Worker-Setup für react-pdf v10 + pdfjs-dist v5.
 *
 * Vite kann einen Bare-Specifier NICHT über `new URL('pdfjs-dist/…', import.meta.url)`
 * auflösen — das wurde relativ zum Feature-Ordner interpretiert und schlug im Dev-Server
 * als „Failed to fetch dynamically imported module" fehl. Der `?url`-Import lässt Vite das
 * Paket korrekt auflösen (Dev serviert es, Build emittiert es als Asset). `pdfjs-dist` ist
 * dafür als direkte Dependency in der **exakt** von react-pdf genutzten Version gepinnt —
 * eine Versions-Divergenz zwischen Worker und pdf.js-Runtime wirft sonst „API version does
 * not match Worker version". Muss einmal importiert werden, bevor Document/Page rendert.
 */
import { pdfjs } from 'react-pdf';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
